import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	shouldIndent: boolean
}

export const Container = styled.li<Props>`
	border-top: 1px solid ${helpers.color.separator};
	padding: 12px ${({ shouldIndent }) => (shouldIndent ? 12 : 0)}px;
	list-style: none;
	color: ${helpers.color.textMuted};
	font-size: 14px;
	margin: 0;

	&:first-child {
		border-top: none;
	}
`
